import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AppNavigationModule } from 'app/shared/navigation/navigation.module';
import { UserModule } from 'app/layout/common/user/user.module';
import { SharedModule } from 'app/shared/shared.module';
import { ModernLayoutComponent } from 'app/layout/layouts/modern/modern.component';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
    declarations: [ModernLayoutComponent],
    imports: [
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        AppNavigationModule,
        UserModule,
        SharedModule,
        TranslocoModule
    ],
    exports: [ModernLayoutComponent],
    providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class ModernLayoutModule {}
